import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=afa6f8e6&scoped=true"
import script from "./LayoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutMenu.vue?vue&type=style&index=0&id=afa6f8e6&prod&scoped=true&lang=scss"
import style1 from "./LayoutMenu.vue?vue&type=style&index=1&id=afa6f8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa6f8e6",
  null
  
)

export default component.exports